import ResourcesListContainer from './resources_list_container';

const ResourcesList = ResourcesListContainer;
export default ResourcesList;
